import { Token, TokenType } from './Token'

/**
 * Abstract token with permissions capability
 */
export abstract class TokenWithPermissions extends Token {
  constructor(value: string, type: TokenType, expiresAt: Date | null = null) {
    super(value, type, expiresAt)
  }

  /**
   * Extract permissions from token payload
   */
  abstract getPermissions(): string[]

  /**
   * Check if token has specific permission
   */
  hasPermission(permission: string): boolean {
    return this.getPermissions().includes(permission)
  }
}
